import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Restaurant, SubmitRetroCreditException, RetroCreditValidationErrorCode } from '@/models';
import { Routes } from '@/router';
import { RetroCreditState, RetroCreditOrderDetails } from '@/store/retro-credit';

@Component({
    name: 'CmgRetroCredit',
})
export default class CmgRetroCredit extends Vue {
    isSubmitting = false;

    get state() {
        return this.$appStore.state.retroCredit.state;
    }

    onClickStart() {
        this.$services.retroCredit.setInProgress(true);

        this.goToState(RetroCreditState.ZipCodeEntry);
    }

    onRestaurantsSearched(restaurants: Restaurant[]) {
        this.$services.retroCredit.setRetaurants(restaurants);

        this.goToState(RetroCreditState.RestaurantSelection);
    }

    onRestaurantSelected(restaurant: Restaurant) {
        this.$services.retroCredit.setSelectedRestaurant(restaurant);

        this.goToState(RetroCreditState.OrderDetails);
    }

    onSubmit(details: RetroCreditOrderDetails) {
        this.$services.retroCredit.setOrderDetails(details);

        this.submit();
    }

    async submit() {
        const { orderDetails, selectedRestaurant } = this.$appStore.state.retroCredit;
        if (!orderDetails || !selectedRestaurant) {
            this.$services.logger.unreachable('Submit should never be called without order details & a selected restaurant');
            return;
        }

        this.isSubmitting = true;

        try {
            await this.$services.retroCredit.submit({
                restaurantId: selectedRestaurant.restaurantNumber,
                checkNumber: orderDetails.checkNumber,
                transactionDate: orderDetails.purchaseDate,
                transactionAmount: orderDetails.purchaseTotal,
            });

            this.goToState(RetroCreditState.Done);
        } catch (e: any) {
            // TODO-ra3b6n: error handling
            if (e instanceof SubmitRetroCreditException) {
                const error = e.errors[0];
                
                if (error) {
                    switch (error.errorCode) {
                        case RetroCreditValidationErrorCode.ReachedDailyLimit:
                            this.goToState(RetroCreditState.ReachedDailyLimit);
                            break;

                        case RetroCreditValidationErrorCode.ReachedWeeklyLimit:
                            this.goToState(RetroCreditState.ReachedWeeklyLimit);
                            break;
                            
                        case RetroCreditValidationErrorCode.ReachedMonthlyLimit:
                            this.goToState(RetroCreditState.ReachedMonthlyLimit);
                            break;

                        case RetroCreditValidationErrorCode.NotARewardsMember:
                            this.goToState(RetroCreditState.NotARewardsMember);
                            break;

                        case RetroCreditValidationErrorCode.DuplicateRequest:
                            this.goToState(RetroCreditState.DuplicateRequest);
                            break;
                    }
                }
            }

            this.$services.logger.error('Something went wrong while submitting retro credit form', undefined, e);
        } finally {
            this.isSubmitting = false;
        }
    }

    onClickReturnHome() {
        this.$router.push({ name: Routes.Home });
    }

    onClickStartNewRequest() {
        this.$services.ui.nextFocus('retro-credit-landing');
        this.$services.retroCredit.reset();
    }

    private goToState(state: RetroCreditState) {
        this.$services.retroCredit.setState(state);
    }
}
